<template>
    <UiSelect
        :model-value="modelValue"
        placeholder="Rechercher parmi les enfants"
        :options="registrationsOptions"
        name="registration_uuid"
        no-result-text="Aucun enfant trouvé, veuillez affiner votre recherche"
        :loading="loadingStates['registrations.search']"
        @update:model-value="onUpdate"
        @searched="onSearched"
    />
</template>

<script>
import { defineComponent } from 'vue'
import { mapStores } from 'pinia'
import { loadingMixin } from 'abcreche-ui'
import { useRegistrationsStore } from '~~/stores/registrations.js'
import organizationRegistrationsListMixin from '~~/mixins/registrations/organizationRegistrationsListMixin.js'

export default defineComponent({
    mixins: [organizationRegistrationsListMixin, loadingMixin],

    props: {
        modelValue: {
            type: String,
            default: null
        }
    },

    emits: ['update:model-value', 'select-registration'],

    computed: {
        ...mapStores(useRegistrationsStore)
    },

    methods: {
        onSearched (value) {
            this.registrationsStore.$reset()
            this.registrationsStore.filters.status = []
            this.registrationsQueryParameters.search = value
            this.searchRegistrations()
        },

        onUpdate (value) {
            this.$emit('update:model-value', value)
            this.$emit('select-registration', this.registrations.find(registration => registration.uuid === value))
        }
    }

})
</script>
